import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./styles.css";
import "./lista.css";
import "./form.css";
import "./tabela.css";
import { Link, useHistory } from "react-router-dom";

const SidebarSolicitante = (props) => {
  let history = useHistory();
  Axios.defaults.withCredentials = true;

  const [username, setUsuario] = useState([]);

  useEffect(() => {
    Axios.defaults.withCredentials = true;
    Axios.get(`${process.env.REACT_APP_API_BASE_URL}/login`, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then((response) => {
      if (response.data.loggedIn === true) {
        setUsuario(response.data.user[0]);
      }
    });
  }, []);

  return (
    <>
      <div className="div_body">
        <div className="container">
          <nav className="navbar">
            <div className="nav_icon">
              <i className="fa fa-bars" aria-hidden="true"></i>
            </div>
            <div className="navbar__left">
              <a className="active_link" href="/">
                Painel
              </a>
            </div>
            <div className="navbar__right">
              <label>Olá, {username.nome}!</label>
            </div>
          </nav>
          <main>
            <div className="main__container">{props.children}</div>
          </main>
          <div id="sidebar">
            <div className="sidebar__title">
              <div className="sidebar__img">
                <h1>MYDIGICARE - SOLICITANTE</h1>
              </div>
              <i
                className="fa fa-times"
                id="sidebarIcon"
                aria-hidden="true"
              ></i>
            </div>
            <div className="sidebar__menu">
              <div className="sidebar__link">
                <i className="fa fa-home"></i>
                <Link to="/solicitante">Menu Principal</Link>
              </div>
              <br></br>
              <h2>TELECONSULTORIAS</h2>
              <div className="sidebar__link">
                <i className="fa fa-plus"></i>
                <Link to="/solicitante/solicitarTelec">
                  Solicitar Teleconsultoria
                </Link>
              </div>
              <div className="sidebar__link">
                <i className="fa fa-ellipsis-h"></i>
                <Link to="/solicitante/minhasTelecAndamento">
                  Teleconsultorias em Andamento
                </Link>
              </div>
              <div className="sidebar__link">
                <i className="fa fa-check"></i>
                <Link to="/solicitante/minhasTelecEncerradas">
                  Teleconsultorias Encerradas
                </Link>
              </div>
              <div className="sidebar__link">
                <i className="fa fa-clock-o"></i>
                <Link to="/solicitante/minhasTelec">
                  Teleconsultorias Solicitadas
                </Link>
              </div>
              <br></br>
              <div className="sidebar__logout">
                <i className="fa fa-power-off"></i>
                <Link to="/sair">Sair</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarSolicitante;
